import _slicedToArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
/**
 * Listen to the onLoad and onError events on an element
 * can only be used on certain HTML tags
 * @returns some booleans representing the element's state, and some props that need to be spread on
 */

export var useElementStatus = function useElementStatus(
/**
 * A reference to the element you're listening to if it's an image element.
 * Is needed to check if an image is cached if it's an image element, using the complete property on the element as if it is, onLoad won't fire
 * Must be used in conjunction with the returned props
 */
ref) {
  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      loading = _React$useState2[0],
      setLoading = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      loaded = _React$useState4[0],
      setLoaded = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      error = _React$useState6[0],
      setError = _React$useState6[1];

  var onLoad = React.useCallback(function () {
    setLoaded(true);
    setLoading(false);
  }, []);
  var onError = React.useCallback(function () {
    setError(true);
    setLoading(false);
  }, []);
  React.useEffect(function () {
    var _a;

    if ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.complete) {
      setLoaded(true);
    } else {
      setLoading(true);
    }
  }, []);
  return {
    loading: loading,
    error: error,
    loaded: loaded,
    props: {
      onLoad: onLoad,
      onError: onError
    }
  };
};